export default __webpack_public_path__ + "static/media/paging_last_B_active.6894f8b4.svg";